const objeto10 = {
  titulo: `Objetos: Sintaxis de clases`,
  problemas: [
    {
      codigo: 1,
      descripcion: `El JavaScript moderno ha incorporado una nueva sintaxis para definir clases que facilita a programadores que vienen de otros lenguajes.
Una clase es una plantilla para la creación de objetos (muy similar a la función constructora). Las clases se utilizan para representar entidades. Cada clase lo podemos imaginar como un molde que define un conjunto de variables o atributos, y métodos apropiados para operar con dichos datos.
La sintaxis general de una clase es:
<code>
class MiClase {
  // métodos de clase
  constructor() { ... }
  metodo1() { ... }
  metodo2() { ... }
  metodo3() { ... }    
}
</code>
Una clase puede tener un solo constructor, que es un método que se ejecuta automáticamente al crear un objeto de la clase y tiene por objetivo inicializar los atributos del objeto que se esta creando.
Para definir un constructor utilizamos la palabra clave 'constructor', seguidamente los parámetros y finalmente en un bloque de código inicializamos atributos.
`,
      programa: `class Articulo {
  constructor(codigo, descripcion, precio) {
    this.codigo = codigo
    this.descripcion = descripcion
    this.precio = precio
  }
}

const articulo1 = new Articulo(1, "Pizza", 100)
console.log(articulo1.descripcion)`,
      solucion: "'Pizza'",
    }, {
      codigo: 2,
      descripcion: `Además del constructor podemos definir otros métodos, que manipulan los atributos del objeto.`,
      programa: `class Articulo {
  constructor(codigo, descripcion, precio) {
    this.codigo = codigo
    this.descripcion = descripcion
    this.precio = precio
  }

  aumentarPrecio(porcentaje) {
    this.precio = this.precio * (1 + porcentaje / 100)
  }

}

const articulo1 = new Articulo(1, "Pizza", 100)
articulo1.aumentarPrecio(20)
console.log(articulo1.precio)`,
      solucion: "120",
    }, {
      codigo: 3,
      descripcion: ``,
      programa: `class Cuadrado {
  constructor(lado) {
    this.lado = lado
  }
  retornarAarea() {
    return this.lado * this.lado
  }
}

const cuadrado1 = new Cuadrado(5)
const cuadrado2 = new Cuadrado(10)
console.log(cuadrado1.retornarAarea())`,
      solucion: "25",
    }, {
      codigo: 4,
      descripcion: `Al igual que los objetos literales, las clases pueden tener getters y setters.`,
      programa: `class Dado {
  constructor(v) {
    this._valor = v
  } 

  get valor() {
    return this._valor;
  }

  set valor(v) {
    if (v >= 1 && v <= 6) {
      this._valor = v
    } else {
      console.log('Valor incorrecto')
    }
  }
}

const dado1 = new Dado(1)
dado1.valor=6
console.log(dado1.valor)`,
      solucion: "6",
    }, {
      codigo: 5,
      descripcion: `No se pueden llamar a los métodos de una clase directamente, sino a través de una instancia de un objeto de la clase.`,
      programa: `class Libro {
  constructor(titulo, autor, contenido) {
    this.titulo = titulo
    this.autor = autor
    this.contenido = contenido
  }

  mostrarEncabezado() {
    console.log('******************')
  }
}

Libro.mostrarEncabezado()`,
      solucion: "error",
    }, {
      codigo: 6,
      descripcion: `Igual que las funciones podemos plantear expresiones de clase, recordar que debemos acceder a dicha variable una vez definida.`,
      programa: `const Libro = class {
  constructor(titulo, autor, contenido, precio) {
    this.titulo = titulo
    this.autor = autor
    this.contenido = contenido
    this.precio = precio
  }

  esCaro() {
    if (this.precio > 100) {
      console.log('Es caro')
    } else {
      console.log('Es barato')
    }
  }
}

const libro1 = new Libro('Martin Fierro', 'Juan Perez', 'Es muy bueno', 250)
libro1.esCaro()`,
      solucion: "'Es caro'",
    }, {
      codigo: 7,
      descripcion: ``,
      programa: `const libro1 = new Libro('Martin Fierro', 'Juan Perez', 'Es muy bueno', 250)
libro1.esCaro()

const Libro = class {
  constructor(titulo, autor, contenido, precio) {
    this.titulo = titulo
    this.autor = autor
    this.contenido = contenido
    this.precio = precio
  }

  esCaro() {
    if (this.precio > 100) {
      console.log('Es caro')
    } else {
      console.log('Es barato')
    }
  }
}`,
      solucion: "error",
    }, {
      codigo: 8,
      descripcion: `En JavaScript podemos crear una clase anónima, es decir, sin nombre. Hay que asignar a una variable la creación del objeto de la clase anónima y llamar inmediatamente constructor.`,
      programa: `const persona = new (
  class {
    constructor(nombre, apellido, edad) {
      this.nombre = nombre
      this.apellido = apellido
      this.edad = edad
    }

    saludar() {
      console.log("Hola " + this.nombre)
    }
  })("Juan", "Perez", 30)

persona.saludar()`,
      solucion: "'Hola Juan'",
    }, {
      codigo: 9,
      descripcion: `Si por algún motivo debo definir nombres de métodos que incluyan emojis, caracteres en blanco, símbolos especiales etc. luego debo encerrarlos entre comillas y cuando los llamo no puedo utilizar la notación de (.), sino la de corchetes.`,
      programa: `class Persona {
    constructor(nombre, apellido, edad) {
      this.nombre = nombre;
      this.apellido = apellido;
      this.edad = edad;
    }

    '😄'() {
      console.log(this.nombre + ' esta contento')
    }

    '💗'() {
      console.log(this.nombre + ' tiene amor')
    }
  }

  const persona1 = new Persona('Juan', 'Perez', 20)
  persona1['😄']()`,
      solucion: "'Juan esta contento'",
    },{
      codigo: 10,
      descripcion: `Hemos visto métodos de instancias. Pero también es posible definir "métodos estáticos". La diferencia es que los métodos estáticos estan asociados a la clase y no a una instancia de la clase.
Para crear un método estático, debemos usar la palabra reservada "static" antecediendo el nombre del método. Los métodos se llaman directamente a través del nombre de la clase. Un método estático no puede acceder a las variables de instancia de la clase mediante this.`,
      programa: `class Operacion {
  static sumar(x,y) {
    return x + y
  }

  static restar(x,y) {
    return x - y
  }

  static multiplicar(x,y) {
    return x * y
  }

  static dividir(x,y) {
    return x / y
  }

  static potencia(x,y) {
    return Math.pow(x,y)
  }
}

console.log(Operacion.sumar(2,3))`,
      solucion: "5",
    }
  ]
}

export default objeto10;